import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Header from "../../components/headers/MainHeader";
import Footer from "../../components/footers/MainFooterWithLinks";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage";
import DressRoom from "../../images/img/Для бизнеса. КЗ.png";
import { useTranslation } from "react-i18next";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-2xl mx-auto py-8 lg:py-12`;
const HeadingColumn = tw.div`text-left max-w-full mx-auto`;

const GreenLink = styled.p`
    color: #0abd19;
    text-decoration: none;
    font-weight: bold;
`;

const HeadingDescription = styled.p`
    ${tw`font-bold`}
    font-size: 18px;
    line-height: 28px;
    font-weight: normal;
    text-align: left;
    margin: 0;

    @media (min-width: 768px) {
        font-size: 20px;
        line-height: 30px;
    }
`;

const Break = styled.div`${tw`my-4`}`;

export default function ForBusinessPage() {
    const { t } = useTranslation();

    return (
        <AnimationRevealPage>
            <Header
                heading={t("forBusiness.header.title")}
                paragraph={t("forBusiness.header.paragraph")}
                imageSrc={DressRoom}
                roundedHeaderButton={false}
            />
            <Container>
                <Content>
                    <HeadingColumn>
                        <HeadingDescription>
                            {t("forBusiness.body.p1")}
                            <Break />
                            {t("forBusiness.body.p2")}{" "}
                            <GreenLink>{t("forBusiness.body.cta")}</GreenLink>
                        </HeadingDescription>
                    </HeadingColumn>
                </Content>
            </Container>
            <Footer />
        </AnimationRevealPage>
    );
}
